export default __webpack_public_path__ + "static/ONT_Wheel_Icon_RGB-db04087a4ba91f1ee36c2c2a204ebe79.png";